document.addEventListener('DOMContentLoaded', function () {
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.getElementById('oe-mobile-menu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  var headerEl = document.querySelector('.oe-header');
  if (headerEl) {
    var onHeaderScroll = function () {
      if (window.scrollY > 12) {
        headerEl.classList.add('is-scrolled');
      } else {
        headerEl.classList.remove('is-scrolled');
      }
    };
    onHeaderScroll();
    window.addEventListener('scroll', onHeaderScroll, { passive: true });
  }

  var mobileSubmenuToggles = document.querySelectorAll('[data-mobile-submenu-toggle]');
  mobileSubmenuToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var submenu = toggle.parentElement.querySelector('[data-mobile-submenu]');
      if (!submenu) return;
      var open = submenu.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  var filterToggle = document.querySelector('[data-filter-toggle]');
  var filterPanel = document.querySelector('[data-filter-panel]');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function () {
      var open = filterPanel.classList.toggle('is-open');
      filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  var sortSelect = document.getElementById('oe-sort-select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function (e) {
      var queryParams = {};
      if (location.search.length) {
        var params = location.search.substr(1).split('&');
        for (var i = 0; i < params.length; i++) {
          var kv = params[i].split('=');
          if (kv.length) queryParams[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1] || '');
        }
      }
      queryParams.sort_by = e.target.value;
      location.search = new URLSearchParams(queryParams).toString();
    });
  }

  var recommendationSections = document.querySelectorAll('.product-recommendations[data-url]');
  if ('IntersectionObserver' in window && recommendationSections.length) {
    var loadRecommendations = function (el) {
      fetch(el.getAttribute('data-url'))
        .then(function (r) { return r.text(); })
        .then(function (text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var rec = html.querySelector('.product-recommendations');
          if (rec && rec.innerHTML.trim().length) {
            el.innerHTML = rec.innerHTML;
          }
        })
        .catch(function () {});
    };
    var recoObserver = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          loadRecommendations(entry.target);
        }
      });
    }, { rootMargin: '0px 0px 200px 0px' });
    recommendationSections.forEach(function (el) { recoObserver.observe(el); });
  }

  var revealEls = document.querySelectorAll('.oe-reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  var buybox = document.querySelector('.oe-buybox');
  if (buybox) {
    var qtyValueEl = buybox.querySelector('[data-qty-value]');
    var decreaseBtn = buybox.querySelector('[data-qty-decrease]');
    var increaseBtn = buybox.querySelector('[data-qty-increase]');
    var addPriceEl = buybox.querySelector('[data-add-to-cart-price]');
    var variantSelect = buybox.querySelector('[data-variant-select]');
    var buyboxAddBtn = buybox.querySelector('[data-buybox-add]');
    var buyboxBuyNowBtn = buybox.querySelector('[data-buybox-buy-now]');

    var getQty = function () { return parseInt(qtyValueEl.textContent, 10) || 1; };
    var getUnitPrice = function () { return parseInt(buybox.getAttribute('data-unit-price'), 10) || 0; };
    var getStock = function () {
      var s = buybox.getAttribute('data-stock');
      return s === '' || s === null ? null : parseInt(s, 10);
    };
    var updatePriceDisplay = function () {
      if (addPriceEl) addPriceEl.textContent = money(getUnitPrice() * getQty());
    };
    var setQty = function (next) {
      var stock = getStock();
      if (next < 1) next = 1;
      if (stock !== null && stock > 0 && next > stock) next = stock;
      qtyValueEl.textContent = next;
      updatePriceDisplay();
    };

    if (decreaseBtn) decreaseBtn.addEventListener('click', function () { setQty(getQty() - 1); });
    if (increaseBtn) increaseBtn.addEventListener('click', function () { setQty(getQty() + 1); });

    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        var opt = variantSelect.options[variantSelect.selectedIndex];
        buybox.setAttribute('data-variant-id', variantSelect.value);
        buybox.setAttribute('data-unit-price', opt.getAttribute('data-price') || '0');
        buybox.setAttribute('data-stock', opt.getAttribute('data-stock') || '');
        setQty(1);
      });
    }

    var addBuyboxToCart = function () {
      var variantId = buybox.getAttribute('data-variant-id');
      if (!variantId) return Promise.reject();
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: getQty() }),
      }).then(function (r) { return r.json(); });
    };

    if (buyboxAddBtn) {
      buyboxAddBtn.addEventListener('click', function () {
        addBuyboxToCart().then(function () { openCart(); }).catch(function () {});
      });
    }
    if (buyboxBuyNowBtn) {
      buyboxBuyNowBtn.addEventListener('click', function () {
        addBuyboxToCart().then(function () { window.location.href = '/checkout'; }).catch(function () {});
      });
    }

    updatePriceDisplay();
  }

  document.querySelectorAll('.oe-product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-full');
      var mainImg = document.querySelector('.oe-product-main-image img');
      if (full && mainImg) {
        mainImg.setAttribute('src', full);
        document.querySelectorAll('.oe-product-thumb').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      }
    });
  });

  var overlay = document.getElementById('oe-cart-overlay');
  var drawer = document.getElementById('oe-cart-drawer');

  function openCart() { if (overlay) overlay.classList.add('is-open'); if (drawer) drawer.classList.add('is-open'); renderCart(); }
  function closeCart() { if (overlay) overlay.classList.remove('is-open'); if (drawer) drawer.classList.remove('is-open'); }

  document.querySelectorAll('[data-cart-open]').forEach(function (btn) { btn.addEventListener('click', openCart); });
  document.querySelectorAll('[data-cart-close]').forEach(function (btn) { btn.addEventListener('click', closeCart); });

  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  function updateCartCount(count) { document.querySelectorAll('.oe-cart-count').forEach(function (el) { el.textContent = count; }); }

  function renderCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      updateCartCount(cart.item_count);
      var body = document.querySelector('.oe-cart-body');
      var footer = document.querySelector('.oe-cart-footer');
      if (!body) return;
      if (!cart.items.length) {
        body.innerHTML = '<div class="oe-cart-empty"><p class="oe-display" style="font-size:20px;">Your cart is empty</p>' +
          '<p style="margin-top:8px;max-width:220px;color:var(--eo-ink-500);font-size:13px;">Explore antique dzi amulets and Himalayan eye beads.</p>' +
          '<a href="/collections/all" class="oe-btn oe-btn-primary" style="margin-top:18px;background:var(--eo-ink-900);color:var(--eo-sand-50);">Browse listings</a></div>';
        if (footer) footer.style.display = 'none';
        return;
      }
      if (footer) footer.style.display = 'block';
      var html = '';
      cart.items.forEach(function (item) {
        html += '<div class="oe-cart-line">' + (item.image ? '<img src="' + item.image + '&width=140" alt="">' : '') +
          '<div><p style="font-size:14px;">' + item.product_title + '</p>' +
          '<p style="margin-top:4px;font-size:12.5px;color:var(--eo-ink-500);">Qty ' + item.quantity + ' · ' + money(item.final_line_price) + '</p></div></div>';
      });
      body.innerHTML = html;
      var subtotalEl = document.querySelector('.oe-cart-subtotal-amount');
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);
    }).catch(function () {});
  }

  document.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var card = btn.closest('[data-variant-id]');
      var variantId = card ? card.getAttribute('data-variant-id') : null;
      if (!variantId) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      }).then(function (r) { return r.json(); }).then(function () { openCart(); }).catch(function () {});
    });
  });

  renderCart();
});
